import api from './api'
import auth from './auth'
import db from './db'
import history from './history'
import images from './images'
import products from './products'
import sync from './sync'

export default {
    db: db,
    products: products,
    images: images,
    auth: auth,
    api: api,
    sync: sync,
    history: history,
}